<template>
  <div>
    <!-- <el-button @click="$router.push({name:'TableDrag'})">
      实现鼠标拖拽选中
    </el-button> -->
    <my-date></my-date>
  </div>
</template>
<script>
import MyDate from "./MyDate.vue";
export default {
  data() {
    return {};
  },
  components: {
    MyDate,
  },
};
</script>